import React, { useState } from 'react'
import './pagination.scss'

export default function PaginationComponent(props) {
  const isPaginationVisible = parseInt(props.pageLength) / 2 > 1 ? true : false
  //const pageLenth = Math.round(parseInt(props.pageLength) / 5);
  const pageLenth = parseInt(props.pageLength) / 5 > 1 && parseInt(props.pageLength) / 5 < 2 ? 2 : Math.round(parseInt(props.pageLength) / 5);
  

  const pagearray = []
  for (let i = 1; i <= pageLenth; i++) {
    pagearray.push(i)
  }
  return (
    <>
      {isPaginationVisible ? (
        <nav aria-label="Page navigation" className="custom-pagination">
          <ul className="pagination">
            {/* <li className="page-item">
              <a className="page-link" href="#">
                Previous
              </a>
            </li> */}
            {pagearray.map((item, index) => (
              <li className="page-item">
                {(index + 1)  === props.selectedPagination ? (
                  <span className="page-link disabled" onClick={props.paginationChange}>
                    {item}
                  </span>
                ) : (
                  <span className="page-link" onClick={props.paginationChange}>{item}</span>
                )}
              </li>
            ))}
            {/* <li className="page-item">
              <a className="page-link" href="#">
                Next
              </a>
            </li> */}
          </ul>
        </nav>
      ) : (
        ''
      )}
    </>
  )
}
